var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 6C8.16094 6 5.17031 8.2875 1.5 12C4.65938 15.1734 7.3125 18 12 18C16.6828 18 20.1281 14.4187 22.5 12.0656C20.0719 9.30937 16.6313 6 12 6ZM12 16.2797C9.68437 16.2797 7.8 14.3578 7.8 12C7.8 9.6375 9.68437 7.72031 12 7.72031C14.3156 7.72031 16.2 9.64219 16.2 12C16.2 14.3625 14.3156 16.2797 12 16.2797Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 10.5C12.0004 10.1297 12.1363 9.79221 12.3566 9.52971C12.2395 9.51096 12.1223 9.50159 12.0004 9.50159C10.6504 9.50159 9.54883 10.6219 9.54883 12C9.54883 13.3781 10.6504 14.4985 12.0004 14.4985C13.3504 14.4985 14.452 13.3781 14.452 12C14.452 11.8922 14.4426 11.7844 14.4332 11.6766C14.1754 11.8781 13.8566 12 13.5051 12C12.6707 12 12.0004 11.3297 12.0004 10.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.227ae2b0871718fa8d354dd167e7ead1.svg";
export { ForwardRef as ReactComponent };